import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { appActions, appSelectors } from '../reducer/app-reducer';
import { withRouter } from 'react-router-dom';
import styled from '@emotion/styled';
import { appMainBackground, appTextColor } from '../../../styles/colors';
import { footerHeight, headerHeight} from '../../../styles/constants';
import { ltrDir, rtlDir } from '../constants';

import { AppHeaderContainer as AppHeader } from './AppHeader';
import { AppFooterContainer as AppFooter } from './AppFooter';
import { ssoLoginSelectors } from '../../login/reducer/sso-login-reducer';
import { withWindowDimensions } from '@rosetta/react-common-ui';
import { isMobile as isMobileDetected } from 'react-device-detect';
// thanks, IE
import 'babel-polyfill';
import { lionSelectors } from '@rosetta/react-lion/dist/index';

let isRtl = false;

const AppDiv = styled.div((props) => {
  let style = {
    boxSizing: 'border-box',
    '& *': {
      boxSizing: 'border-box'
    },
    fontSize: '0px',
    color: appTextColor,
    backgroundColor: appMainBackground,
    cursor: 'default',
    userSelect: 'none',
    position: !props.isMobile ? 'absolute' : 'relative',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px'
  };

  if (isRtl) {
    style['& *'].direction = rtlDir;
  } else {
    style['& *'].direction = ltrDir;
  }

  return style;
});

const AppContent = styled.div((props) => {
  let style = {
    position: !props.isMobile ? 'absolute' : 'relative',
    left: 0,
    right: 0,
    minHeight: props.windowHeight - 248 + 'px' // push footer to bottom of view
  };
  if (!props.isMobile) {
    if (props.hasHeader) {
      style.top = headerHeight;
    }
    if (props.hasFooter) {
      style.bottom = footerHeight;
    }
  }

  return style;
});

export class App extends PureComponent {
  constructor(props) {
    super(props);
    const body = document.body;
    body.style.position = 'absolute';
    body.style.boxSizing = 'border-box';
    body.style.top = '0px';
    body.style.right = '0px';
    body.style.bottom = '0px';
    body.style.left = '0px';
    body.style.margin = '0px';
    body.style.padding = '0px';
    body.style.backgroundColor = appMainBackground;
    body.style.fontFamily = 'NotoSans, NotoSans_Hebrew, NotoSans_Arabic, NotoSans_Hindi, NotoSans_JP, NotoSans_KR, NotoSans_TC, NotoSans_SC';

    this.state = {
      localizedToLanguage: '',
      unsupportedBrowser: false,
      unsupportedOriginUrl: ''
    };

    this.props.initApp();
  }

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (nextProps.lionLoaded && nextProps.lionLanguage !== prevState.localizedToLanguage) {
      const appTitle = nextProps.lionTranslateString('_html_page_title').replace(/&reg;/g, '\u00AE');
      document.title = appTitle;
      return {
        localizedToLanguage: nextProps.lionLanguage
      };
    }
    if (nextProps.unsupportedBrowser && prevState.unsupportedBrowser !== nextProps.unsupportedBrowser) {
      nextProps.setUnsupportedOriginUrl(nextProps.location.pathname);
      nextProps.history.push('/unsupported');
      return { unsupportedBrowser: nextProps.unsupportedBrowser, unsupportedOriginUrl: nextProps.location.pathname };
    }
    // logoutUser in regiser-sagas redirects user to /login page, this will make sure we still show them /unsupported
    if (nextProps.location.pathname === '/login' && prevState.unsupportedOriginUrl.includes('register')) {
      nextProps.history.push('/unsupported');
      return null;
    }
    return null;
  };

  render = () => {
    isRtl = this.props.isInterfaceRtl;
    const isMobile = isMobileDetected;

    let header = null;
    let footer = null;
    if (this.props.location.pathname.indexOf('objectives') >= 0) {
      header = <AppHeader />;
    } else if (
      this.props.location.pathname.indexOf('mobilessologin') === -1 &&
      this.props.location.pathname.indexOf('ssoerror') === -1 &&
      !this.props.ssoLoginAttemptPending
    ) {
      header = <AppHeader />;
      footer = <AppFooter />;
    }

    return (
      <AppDiv data-qa="AppDiv" isMobile={isMobile}>
        {header}
        <AppContent
          data-qa="AppContent"
          hasHeader={header !== null}
          hasFooter={footer !== null}
          isMobile={isMobile}
          windowHeight={this.props.clientHeight}
        >
          {this.props.children}
        </AppContent>
        {footer}
      </AppDiv>
    );
  };
}

App.propTypes = {};

const mapStateToProps = (state, ownprops) => ({
  isInterfaceRtl: appSelectors.isInterfaceRtl(state),
  unsupportedBrowser: appSelectors.getUnsupportedBrowser(state),
  ssoLoginAttemptPending: ssoLoginSelectors.ssoLoginAttemptPending(state),
  lionLanguage: lionSelectors.getLionLanguage(state),
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  }
});

export const AppContainer = withRouter(
  connect(
    mapStateToProps,
    appActions
  )(withWindowDimensions(App))
);



// WEBPACK FOOTER //
// ./src/modules/app/components/App.jsx